import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100px;
`;

const Image = styled.div`
  background: url(${props => props.bgUrl}) no-repeat center center;
  background-size: cover;
  height: 185px;
  transition: 0.2s linear;
  border-radius: 12px;
  @media (max-width: 768px) {
    height: 150px;
  }
`;

const Char = styled.div`
  margin-top: 10px;
  text-align: center;
`;

const ImageContainer = styled.div`
  position: relative;
`;

export const SeasonPage = ({ name, poster }) => {
  return (
    <Container>
      <ImageContainer>
        <Image
          bgUrl={
            poster
              ? `https://image.tmdb.org/t/p/original/${poster}`
              : require('../../assets/noPosterSmall.png').default
          }
        />
      </ImageContainer>
      <Char>{name}</Char>
    </Container>
  );
};
